export default {
  message: {
    menu: ["เกี่ยวกับ", "สินค้า", "ติดต่อ", "สถานที่ขาย", "หน้าหลัก"],
    section2: {
      title: ["ดีต่อสุขภาพ", "เจ", "ทุกเพศทุกวัย"],
      text: [
        "Huahed ผลิตจากเห็ดเพื่อสุขภาพเติบโตจากรำข้าว ผ่านกระบวนการผลิตภายใต้มาตรฐาน GMP Huahed มีไฟเบอร์โปรตีนและวิตามินบีและซีสูง Huahed ไม่ใช้สารกันบูดและสารเติมแต่ง เป็นอาหารว่างที่ดีต่อสุขภาพสำหรับทุกคนทุกวัย",
        "ทำจากเห็ดเข็มทอง และเห็ดนางฟ้า",
        "คัดเฉพาะเห็ดอ่อน เพื่อให้ได้กลิ่นและรสชาติที่ดีที่สุด อร่อย อีกทั้งยังะมีประโยชน์ กินได้ทุกเพศทุกวัย"
      ]
    },
    section3: {
      title: [
        "เห็ดเข็มกรอบ",
        "เห็ดนางฟ้ากรอบ",
        "เห็ดเข็มกรอบ",
        "เห็ดนางฟ้ากรอบ"
      ],
      sub: ["ต้นตำหรับ", "ต้นตำหรับ", "เผ็ด", "ต้มยำ"],
      button: "สินค้า"
    },
    section4: {
      title: "หาซื้อได้ที่"
    },
    footer: {
      r1: "ข้อตกลง & ความเป็นส่วนตัว",
      r2:
        "42/3 ซอยพหลโยธิน 11 ถนนพหลโยธิน แขวง พญาไท เขต พญาไท กรุงเทพมหานคร 10400",
      r3: "โซเชียล"
    },
    about: {
      section1: {
        text:
          "บริษัท มายากานต์จำกัด ทางเลือกใหม่สำหรับอาหารว่างเพื่อสุขภาพ ออกสู่ตลาดครั้งแรกวันที่ 19 สิงหาคม 2558 ในปัจจุบันเป็นผู้นำในขนมชิปเห็ดกรอบ ธุรกิจของเราคือผลิตและจัดจำหน่ายขนมขบเคี้ยวเห็ดกรอบ ผลิตภัณฑ์เช่นเห็ดเข็มทองกรอบ, เห็ดนางฟ้ากรอบ ภายใต้ตราสินค้าของบริษัท มายากานต์จำกัด ตรา “หัวเห็ด”, กว่า 4 ปีของเรา เรามีความมุ่งมั่นที่จะดำเนินการรักษาคุณภาพและพัฒนาผลิตภัณฑ์ของเราให้มีคุณภาพสูง เราเริ่มควบคุมคุณภาพตั้งแต่ขั้นตอนปลูกเห็ด, ขนมของเราทำจากเห็ดปลอดสาร ปลูกในพื้นที่ปิดผ่านกระบวนการผลิตที่ได้มาตรฐาน ไม่มีสารเติมแต่งและไม่มีสารกันบูดเพื่อตอบสนองความพึงพอใจสูงสุดของลูกค้าและผู้บริโภคสามารถอร่อยกับสินค้าของเราได้ตลอดเวลา",
        title: "เกี่ยวกับ"
      },
      section2: {
        title: "เกี่ยวกับเรา",
        text: [
          "บริษัท มายากานต์จำกัด ทางเลือกใหม่สำหรับอาหารว่างเพื่อสุขภาพ ออกสู่ตลาดครั้งแรกวันที่ 19 สิงหาคม 2558 ในปัจจุบันเป็นผู้นำในขนมชิปเห็ดกรอบ ธุรกิจของเราคือผลิตและจัดจำหน่ายขนมขบเคี้ยวเห็ดกรอบ ผลิตภัณฑ์เช่นเห็ดเข็มทองกรอบ, เห็ดนางฟ้ากรอบ ภายใต้ตราสินค้าของบริษัท มายากานต์จำกัด ตรา “หัวเห็ด”, กว่า 4 ปีของเรา เรามีความมุ่งมั่นที่จะดำเนินการรักษาคุณภาพและพัฒนาผลิตภัณฑ์ของเราให้มีคุณภาพสูง เราเริ่มควบคุมคุณภาพตั้งแต่ขั้นตอนปลูกเห็ด, ขนมของเราทำจากเห็ดปลอดสาร ปลูกในพื้นที่ปิดผ่านกระบวนการผลิตที่ได้มาตรฐาน ไม่มีสารเติมแต่งและไม่มีสารกันบูดเพื่อตอบสนองความพึงพอใจสูงสุดของลูกค้าและผู้บริโภคสามารถอร่อยกับสินค้าของเราได้ตลอดเวลา"
        ]
      }
    },
    product: {
      title: "ผลิตภัณฑ์",
      button: "สถานที่จำหน่าย",
      item: [
        {
          title: "เห็ดเข็มทองกรอบ รสดั้งเดิม",
          text:
            "เห็ดเข็มทองกรอบรสดั้งเดิม ทำจากเห็ดเข็มทอง ปลอดสาร ให้โปรตีนวิตามิน B มีไฟเบอร์สูงและมีธาตุเหล็ก เหมาะกับทุกเพศทุกวัย อร่อยมีประโยชน์ เก็บรักษาได้ถึง 12 เดือน"
        },
        {
          title: "เห็ดนางฟ้ากรอบ รสต้มยำ",
          text:
            "เห็ดนางฟ้ากรอบรสต้มยำ ทำจากเห็ดนางฟ้า ปลอดสาร ให้โปรตีนวิตามิน C มีไฟเบอร์สูงและมีธาตุเหล็ก เหมาะกับทุกเพศทุกวัย อร่อยมีประโยชน์ เก็บรักษาได้ถึง 12 เดือน"
        },
        {
          title: "เห็ดนางฟ้ากรอบ รสดั้งเดิม",
          text:
            "เห็ดนางฟ้ากรอบรสดั้งเดิม ทำจากเห็ดนางฟ้า ปลอดสาร ให้โปรตีนวิตามิน C มีไฟเบอร์สูงและมีธาตุเหล็ก เหมาะกับทุกเพศทุกวัย อร่อยมีประโยชน์ เก็บรักษาได้ถึง 12 เดือน"
        },
        {
          title: "เห็ดเข็มทองกรอบ รสเผ็ด",
          text:
            "เห็ดเข็มทองกรอบรสเผ็ด ทำจากเห็ดเข็มทอง ปลอดสาร ให้โปรตีนวิตามิน B มีไฟเบอร์สูงและมีธาตุเหล็ก เหมาะกับทุกเพศทุกวัย อร่อยมีประโยชน์ เก็บรักษาได้ถึง 12 เดือน"
        }
      ]
    },
    contact: {
      title: ["ติดต่อเรา", "ทิ้งข้อความกับเรา"],
      address: [
        {
          title: "ที่อยู่",
          text:
            "42/3 ซอยพหลโยธิน 11 ถนนพหลโยธิน แขวง พญาไท เขต พญาไท กรุงเทพมหานคร 10400"
        },
        {
          title: "อีเมลล์",
          text: "sales@mayanakarn.com"
        },
        {
          title: "เบอร์โทร",
          text: "0922749396"
        }
      ],
      form: [
        "ชื่อของคุณ",
        "หัวข้อ",
        "อีเมลล์ของคุณ",
        "เบอร์โทรของคุณ",
        "ข้อความของคุณ"
      ],
      button: "ส่ง"
    },
    available: {
      title: "หาซื้อสินค้าของเรา",
      text:
        "หัวเห็ดกรอบปัจจุบันจำหน่ายสินค้าผ่านร้านค้าชั้นนำทั่วไป เช่น Tops SuperMarket, Central Food Hall, Gourmet Market, Home Fresh mart, Siam Paragon, ร้านสะดวกซื้อเช่น 7Eleven หรือห้าง ไฮเปอร์มาร์เก็ต เช่น Tesco, Big C และร้านค้าทั่วไปมากกว่า 400 แห่งทั่วประเทศ"
    },
    privacy: {
      title: "PRIVACY & TERMS",
      content: [
        {
          title: "Privacy Policy of huahed",
          child: [
            `huahed operates the http://mayanakarn.com/ website, which provides the SERVICE.
            This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the huahed website.`,
            `If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.`,
            `The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at huahed.vasin.me, unless otherwise defined in this Privacy Policy. Our Privacy Policy was created with the help of the Privacy Policy Template.`
          ]
        },
        {
          title: "Information Collection and Use",
          child: [
            `For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.`
          ]
        },
        {
          title: "Log Data",
          child: [
            `We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.`
          ]
        },
        {
          title: "Cookies",
          child: [
            `Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.`,
            `Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.`
          ]
        },
        {
          title: "Service Providers",
          child: [
            `We may employ third-party companies and individuals due to the following reasons`,
            ` - To facilitate our Service;`,
            ` - To provide the Service on our behalf;`,
            ` - To perform Service-related services; or`,
            ` - To assist us in analyzing how our Service is used.`,
            `We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.`
          ]
        },
        {
          title: "Security",
          child: [
            `We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.`
          ]
        },
        {
          title: "Links to Other Sites",
          child: [
            `Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.`
          ]
        },
        {
          title: "Children’s Privacy",
          child: [
            `Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.`
          ]
        },
        {
          title: "Changes to This Privacy Policy",
          child: [
            `We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.`
          ]
        },
        {
          title: "Contact Us",
          child: [
            `If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.`
          ]
        }
      ]
    }
  }
};
